module.exports = __webpack_public_path__ + "static/media/activity-marker.8e10ece3.png";